import { AuctionBidDTO } from "./auctionBidDTO";
import { AuctionScheduleDTO } from "./auctionScheduleDTO";

export class AuctionDTO{
    public id!:number;
    public auctionType?:number;
    public startPrice?:number;
    public endPrice?:number;
    public reservePrice?:number;
    public reserveMet:boolean = false;
    public buyNowPrice?:number;
    public amountToAuthorize?:number;
    public buyerPremium?:number;
    public deposit?:number;
    public depositValue?:number;
    public securedPrivateAuction:boolean = false;
    public privateBids:boolean = false;
    public feature:boolean = false;
    public comingSoon:boolean = false;
    public schedule?:AuctionScheduleDTO[];
    public scheduleSeqNo?:number;
    public auctionNonComplianceReasons?:string;
    public legalAdId?:number;
    public legalAdConfirmed:boolean = false;
    public auctionStatus!:number;
    public bids?:AuctionBidDTO[];
    public auctionIsLive:boolean = false;
    public auctionAutoLive:boolean = false;
    public increment?:number;
    public requiresNDA:boolean = false;
    public hasBackupBuyNow:boolean = false;
    public suspendBidsSeconds:number = 0;
    public suspendBuyNowSeconds:number = 0;
    public salePendingSeconds:number = 0;
    public checklistItemsStatus?:string;
    public auctionIsPostponed:boolean = false;
    public auctionIsCancelled:boolean = false;
    public auctionIsClosed:boolean = false;
    public statusChangeReasons?:StatusChangeReasonDTO[];
    public purchaseAgreementTemplateId?:number;
    public buyerUploadsRequired?:string;
    public showReserveMet:boolean = false;
    public leads?:string; //json
    public saleStatus?:number;

    constructor(){

    }
   
}

export class ChecklistItemStatusDTO{
    checklistItemId!:number;
    checked:boolean = false;
    remarks?:string;
    timestamp!:string;
    username!:string;
    history:ChecklistItemStatusHistoryDTO[];
    
    constructor(){
        this.history=[];
    }
}

export class ChecklistItemStatusHistoryDTO{
    checked:boolean = false;
    remarks?:string;
    timestamp!:string;
    username!:string;
}

export class StatusChangeReasonDTO{
    status!:string;
    statusReason!:string;
}